<template>
	<div class="plus" style="">
		<Tou ref="myElement">
			<template v-slot:plusMenuTwo>
				<div class="flex a-center flex-wrap j-center pt-27 pb-24 head1 bj-0 " style="border-top: 1px #f5f5f5 solid;">
					<!-- <div class="flex a-center cur_pointer ys-33" @click="daikaiwaibu"> -->
					<div class="flex a-center ys-33 mr-96" style=" color: red;">
						<el-image fit="contain" class=" mr-7" :src="require('@/assets/pc/plus/plus1.png')" alt="" />
						{{gudingziduan.plus.NotaMember}}
					</div>
					<div class="flex a-center cur_pointer ys-33 " @click="plusxq">
						<el-image fit="contain" class=" mr-7" :src="require('@/assets/pc/plus/plus2.png')" alt="" />
						{{gudingziduan.plus.Alreadya}}
					</div>
					<!-- <div class="flex a-center cur_pointer ys-33 ml-96" @click="$dakai('/user-Profile')">
						<el-image fit="contain" class=" mr-7" :src="require('@/assets/pc/plus/plus2.png')" alt="" />
						Login
					</div> -->
				</div>

			</template>
		</Tou>

		<!-- <div class="flex a-center j-center pt-27 pb-24 head1 bj-0 ">
			<div class="flex a-center cur_pointer ys-33" @click="dialog2 = true">
				<el-image fit="contain" class=" mr-7" :src="require('@/assets/pc/plus/plus1.png')" alt="" />
				Learning Center
			</div>
			<div class="flex a-center cur_pointer ys-33 ml-96" @click="dialog = true">
				<el-image fit="contain" class=" mr-7" :src="require('@/assets/pc/plus/plus2.png')" alt="" />
				Login
			</div>
			<div class="flex a-center cur_pointer ys-33 ml-96" @click="$dakai('login')">
				<el-image fit="contain" class=" mr-7" :src="require('@/assets/pc/plus/plus2.png')" alt="" />
				Login
			</div>
		</div> -->



		<div class="bj-0 head2" >
			<!-- <el-image fit="fill" class="banner mr-7" :src="require('@/assets/pc/plus/plus3.png')" alt="" /> -->
			<el-image fit="fill" class="banner" style="width:100%"  :src="l.image" v-for="(l,i) in lunbolist" alt="" v-if="lunbolist.length>0 && i==0"/>
			<el-image fit="fill" class="banner" style="width:100%" :src="require('@/assets/pc/plus/plus3.png')" alt="" v-if="lunbolist.length==0"/>
			<div class="ys-15 w100 t-center tit-42 B-700 pt-82 pb-87 montserBold wow fadeInUp" id="section2">{{gudingziduan.plus.NOTAMEMBERYET}}
			</div>
			<div class="head2_zilBox flex j-between w1500 pb-140">
				<!-- <div class="w48 head2_zil wow fadeInUp"  v-for="(l,i) in liuchenglie" :data-wow-delay= "i*.2 + 's'">
					<div class="flex a-center j-between le">
						<div class="w70">
							<div class="tit-36 montserBold" style="color: #D61518;">{{l.title}}</div>
							<div class="tit-30 ys-33">{{l.title2}}</div>
						</div>
						<div class="head2_tt flex a-center j-center">
							<el-image fit="contain" class=" ml-15" :src="require(`@/assets/pc/plus/plus_0${i}.png`)"          alt="" />
						</div>
					</div>
					<div class="re">    
						<div class="flex mt-40 a-right">
							<div class="pt-16 pb-16 mr-16 pl-30 pr-30 br-32 tit-20 ys-0 cur_pointer t-center more1" style="background: linear-gradient(108deg,#fc6148 3%, #e80e1a 100%);" @click="tiaodenglu(l.url)" v-if="i==0">{{l.anniu}}</div>
							<div class="pt-16 pb-16 mr-16 pl-30 pr-30 br-32 tit-20 ys-0 cur_pointer t-center more1" style="background: linear-gradient(108deg,#fc6148 3%, #e80e1a 100%);" @click.stop="daikaiUrl(l.url,i)" v-else>{{l.anniu}}</div>
							<div class="tit-14 flex1" style="color: #686868;" >{{l.text2}}</div>
						</div>
						<div v-if="i==0" class="tit-18 mt-25 cur_pointer" style="color: #666666;" @click.stop="daikaiUrl(l.url2,i)">New to SEMS? <span style="font-weight: bold;text-decoration: underline;">Register</span> now and join us!</div>
						<div v-else class="tit-18 mt-25 cur_pointer" style="color: #666666;" @click.stop="daikaiUrl(l.url2,3)">Learn First: Explore the <i class="xiahuaxian " style="font-weight: bold;">GW Plus+ Exam Preparation Playlist</i> </div>
					</div>
				</div> -->
				
				<div class="w48 head2_zil wow fadeInUp"  :data-wow-delay= "0*.2 + 's'">
					<div class="flex a-center j-between le">
						<div class="w70">
							<div class="tit-36 montserBold" style="color: #D61518;">{{gudingziduan.plus.PREPARE}}</div>
							<div class="tit-30 ys-33">{{gudingziduan.plus.LoginwithSEMS}}</div>
						</div>
						<div class="head2_tt flex a-center j-center">
							<el-image fit="contain" class=" ml-15" :src="require(`@/assets/pc/plus/plus_00.png`)"          alt="" />
						</div>
					</div>
					<div class="re">    
						<div class="flex mt-40 a-right">
							<div class="pt-16 pb-16 mr-16 pl-30 pr-30 br-32 tit-20 ys-0 cur_pointer t-center more1" style="background: linear-gradient(108deg,#fc6148 3%, #e80e1a 100%);" @click="tiaodenglu('login_in')">{{gudingziduan.plus.Loginnow}}</div>
							<div class="tit-14 flex1" style="color: #686868;" >{{gudingziduan.plus.UseaSEMS}}</div>
						</div>
						<div class="tit-18 mt-25 cur_pointer" style="color: #666666;" @click.stop="daikaiUrl(0)">{{gudingziduan.plus.NewtoSEMS}} <span style="font-weight: bold;text-decoration: underline;">{{gudingziduan.plus.Register}}</span>{{gudingziduan.plus.nowandjoin}}</div>
					<div class="tit-14  cur_pointer" style="color: #666666;" @click.stop="daikaiUrl(4)"><span style="font-weight: bold;text-decoration: underline;">Log in to SEMS</span>to upgrade to Organization representative account!</div>
					</div>
				</div>
				<div class="w48 head2_zil wow fadeInUp"  :data-wow-delay= "1*.2 + 's'">
					<div class="flex a-center j-between le">
						<div class="w70">
							<div class="tit-36 montserBold" style="color: #D61518;">{{gudingziduan.plus.QUALIFY}}</div>
							<div class="tit-30 ys-33">{{gudingziduan.plus.PasstheExam}}</div>
						</div>
						<div class="head2_tt flex a-center j-center">
							<el-image fit="contain" class=" ml-15" :src="require(`@/assets/pc/plus/plus_01.png`)"          alt="" />
						</div>
					</div>
					<div class="re">    
						<div class="flex mt-40 a-right">
							<div class="pt-16 pb-16 mr-16 pl-30 pr-30 br-32 tit-20 ys-0 cur_pointer t-center more1" style="background: linear-gradient(108deg,#fc6148 3%, #e80e1a 100%);" @click.stop="daikaiUrl(1)">{{gudingziduan.plus.StartExam}}</div>
							<div class="tit-14 flex1" style="color: #686868;" >{{gudingziduan.plus.OnlySEMS}}</div>
						</div>
						<div  v-if="yy!='PK'" class="tit-18 mt-25 cur_pointer" style="color: #666666;" @click.stop="daikaiUrl(3)">{{gudingziduan.plus.LearnFirst}} <i class="xiahuaxian " style="font-weight: bold;">{{gudingziduan.plus.LearnFirst2}}</i> </div>
					</div>
				</div>
			</div>
			
		</div>
		<div class="banner2 w100 ys-0 tit-42 flex a-center j-center t-center montserRegular " v-if="yy!='PK'">
				<span class="wow fadeInUp">{{gudingziduan.plus.QualifyFor}}</br>
					{{gudingziduan.plus.BySuccessfully}}</span>
		</div>
		<div class="banner3 pt-100 pb-100 t-center" id="section1">
			<div class="tit-42 B-700 mb-30 montserBold wow fadeInUp">{{gudingziduan.plus.WHYBECOME}}</br>{{gudingziduan.plus.INSTALLERCOMPANY}}
			</div> 
			<div style="color: #666666;" class="wow tit-20 fadeInUp mb-100">{{gudingziduan.plus.AGlobalProgram}}</div>
			<!-- <div class=" flex buzhouNum">
				<div class="buzhou rel w25 flex a-center j-center" v-for="l in 4">
					<div class="bu1 bj-0 br-50 flex a-center j-center">
						<div class="bu2 ys-0 br-50 flex a-center j-center">
							<div class="bu3 br-50 flex a-center j-center montserRegular">{{ l }}</div>
						</div>
					</div>
				</div>
			</div> -->
			
			<div class="rel plusThreList">
				<el-image class="abs" :src="require('@/assets/pc/plus/plus_03.png')" alt="" fit="contain" />
				<div class="flex buzhounr3 j-between w1500">
					<!-- <div class="item flex column a-center w22 pl-10 pr-10 wow fadeInUp" v-for="(l, i) in lie" :data-wow-delay= "i*.2 + 's'">
						<div class="tubb bj-0 flex a-center j-center">
							<div class="tubbb flex a-center j-center">
								<i class="tit-28 ys-0 iconfont" :class="l.icon"></i>
							</div>
						</div>
						<div class="tit-24 mt-40 B-700 mb-20 montserBold">{{ l.title }}</div>
						<div class="tit-18 B-300 title22 " :class=" i==3? 'mb-12' : 'mb-25'" style="color:#666666;">{{ l.title2 }}</div>
						<div class="image11">
							<el-image :src="require(`@/assets/pc/plus/plusfl_${i+1}.png`)" alt="" fit="contain" />
						</div>
					</div> -->
					<div class="item flex column a-center w22 pl-10 pr-10 wow fadeInUp" :data-wow-delay= "0*.2 + 's'">
						<div class="tubb bj-0 flex a-center j-center">
							<div class="tubbb flex a-center j-center">
								<i class="tit-28 ys-0 iconfont icon-zigerenzheng"></i>
							</div>
						</div>
						<div class="tit-24 mt-40 B-700 mb-20 montserBold">{{gudingziduan.plus.QUALIFY}}</div>
						<div class="tit-18 B-300 title22 mb-25" style="color:#666666;">{{gudingziduan.plus.Passthecert}}</div>
						<div class="image11">
							<el-image :src="require(`@/assets/pc/plus/plusfl_1.png`)" alt="" fit="contain" />
						</div>
					</div>
					<div v-if="yy!='PK'" class="item flex column a-center w22 pl-10 pr-10 wow fadeInUp" :data-wow-delay= "1*.2 + 's'">
						<div class="tubb bj-0 flex a-center j-center">
							<div class="tubbb flex a-center j-center">
								<i class="tit-28 ys-0 iconfont icon-anzhuangshigong"></i>
							</div>
						</div>
						<div class="tit-24 mt-40 B-700 mb-20 montserBold">{{gudingziduan.plus.INSTALL}}</div>
						<div class="tit-18 B-300 title22 mb-25" style="color:#666666;">{{gudingziduan.plus.InstallGoodWe}}</div>
						<div class="image11">
							<el-image :src="require(`@/assets/pc/plus/plusfl_2.png`)" alt="" fit="contain" />
						</div>
					</div>
					<div v-if="yy!='PK'" class="item flex column a-center w22 pl-10 pr-10 wow fadeInUp" :data-wow-delay= "2*.2 + 's'">
						<div class="tubb bj-0 flex a-center j-center">
							<div class="tubbb flex a-center j-center">
								<i class="tit-28 ys-0 iconfont icon-zhuanjifen"></i>
							</div>
						</div>
						<div class="tit-24 mt-40 B-700 mb-20 montserBold">{{gudingziduan.plus.EARN}}</div>
						<div class="tit-18 B-300 title22 mb-25" style="color:#666666;">{{gudingziduan.plus.Earnpoints}}</div>
						<div class="image11">
							<el-image :src="require(`@/assets/pc/plus/plusfl_3.png`)" alt="" fit="contain" />
						</div>
					</div>
					<div v-if="yy=='PK'" class="item flex column a-center w22 pl-10 pr-10 wow fadeInUp" :data-wow-delay= "2*.2 + 's'">
						<div class="tubb bj-0 flex a-center j-center">
							<div class="tubbb flex a-center j-center">
								<i class="tit-28 ys-0 iconfont icon-zhuanjifen"></i>
							</div>
						</div>
						<div class="tit-24 mt-40 B-700 mb-20 montserBold">{{gudingziduan.plus.EARN}}</div>
						<div class="tit-18 B-300 title22 mb-25" style="color:#666666;">{{gudingziduan.plus.Earnpoints}}</div>
						<div class="image11">
							<el-image :src="require(`@/assets/pc/plus/plusfl_3.png`)" alt="" fit="contain" />
						</div>
					</div>
					<div class="item flex column a-center w22 pl-10 pr-10 wow fadeInUp" :data-wow-delay= "3*.2 + 's'">
						<div class="tubb bj-0 flex a-center j-center">
							<div class="tubbb flex a-center j-center">
								<i class="tit-28 ys-0 iconfont icon-duihuan"></i>
							</div>
						</div>
						<div class="tit-24 mt-40 B-700 mb-20 montserBold">{{gudingziduan.plus.UPGRADE}}</div>
						<div class="tit-18 B-300 title22 mb-12" style="color:#666666;">{{gudingziduan.plus.Upgradeyour}}</div>
						<div class="image11">
							<el-image :src="require(`@/assets/pc/plus/plusfl_4.png`)" alt="" fit="contain" v-if="yy!='PK'"/>
							<el-image :src="require(`@/assets/pc/plus/plusfl_5x.png`)" alt="" fit="contain" v-else/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bj-0 pt-90 t-center pb-115 plusFour">
			<div class="tit-42 B-700 t-center mb-50 montserBold wow fadeInUp">{{gudingziduan.plus.Preparefor}} </br>{{gudingziduan.plus.withLearning}}</div>
			<div class="tit-19 w50 ys-33 tit2 wow fadeInUp" style="margin: 0 auto; ">{{gudingziduan.plus.Allexamcontent}}</div>
			<div class="ys-0 tit-16 pt-14 pb-14 pl-38 pr-38 mt-50 wow fadeInUp cur_pointer more1" style="background: linear-gradient(87deg,#ff785c 0%, #e70a16 100%);border-radius: 28px;display: inline-block;" @click="$router.push({ name: 'video'})">{{gudingziduan.plus.LearnMore}}</div>
			<div class="list flex flex-wrap w1500 mt-60 wow fadeInUp">
				<div v-for="(l,i) in Playlistshu" @click="plus_xiangqing(l.id)" class="item cur_pointer p-20 flex column moreLie bj-0 br-20 " style="box-shadow: 0px 0px 22.56px 0px rgba(0, 0, 0, 0.03);">
					<div class="imgBox">
						<el-image :src="l.image" alt="" fit="fill" />
						<div class="icBox">
							<span class="iconfont icon-heji"></span>
						</div>
					</div>

					<div class="tit-20 montserRegular flex1 flex a-center">{{l.title}}</div>
				</div>
			</div>
			
			
		</div>
		
		<div class=" pt-110 banner6 pb-150" style="background: #f4f4f4;"  id="section3" v-if="yy!='PK'">
			<div class="w1149">
				<div class="tit-42 montserBold t-center mb-70 wow fadeInUp">FREQUENTLY ASKED QUESTIONS</div>
				<el-collapse v-model="activeNames" @change="handleChange">
					<el-collapse-item :title="t.title" :name="i+1" v-for="(t,i) in wentilie">
						<div>{{t.answer}}</div></el-collapse-item>
			<!-- 		<el-collapse-item title="I can’t find G oodWe inverter’s wireless signal Solar-WiFi." name="2">
						<div>Check the following items:If the inverter was powered on by DC power;Check if the Wi-Fi
							antenna/box on inverter is installed correctly;Check if the yellow POWER LED is blinking. If
							not, please modify the communication mode as per the user manual instructions;If there is no
							wireless signal yet, please reload Wi-Fi as per the user manual instru</div>
					</el-collapse-item>
					<el-collapse-item title="Some accessories are missing." name="3">
						<div>Check the following items:If the inverter was powered on by DC power;Check if the Wi-Fi
							antenna/box on inverter is installed correctly;Check if the yellow POWER LED is blinking. If
							not, please modify the communication mode as per the user manual instructions;If there is no
							wireless signal yet, please reload Wi-Fi as per the user manual instru</div>
					</el-collapse-item>
					<el-collapse-item title="The user manual is lost." name="4">
						<div>Check the following items:If the inverter was powered on by DC power;Check if the Wi-Fi
							antenna/box on inverter is installed correctly;Check if the yellow POWER LED is blinking. If
							not, please modify the communication mode as per the user manual instructions;If there is no
							wireless signal yet, please reload Wi-Fi as per the user manual instru</div>
					</el-collapse-item> -->
				</el-collapse>
			</div>
		</div>
		<div class="w100 bj-0 plusStay">
			<StayTact></StayTact>
		</div>
		<Foot></Foot>
		<el-dialog title="" top="20vh" class="t-center dialogCode" :visible.sync="dialog2">
			<div class="tit-22 B-700 ys-black">Please enter the code</div>
			<div slot="footer" class="flex j-between br-50" style="border:1px solid #d8d8d8;">
				<el-input class="sjj_souinput" v-model="value" placeholder="Please enter an email address"
					placeholder-class="tit-14" placeholder-style="color:#757575;"></el-input>
				<div class="buzhouann br-20 cur_pointer j-center tit-16 ys-0 flex a-center pl-27 pr-27" @click="send">
					Submit</div>
			</div>
		</el-dialog>

		<el-dialog title="" top="20vh" class="t-center juzhong" :visible.sync="dialog">
			<div class="tit-22 B-700 ys-black">Please register for SEMS</div>
			<span slot="footer" class="flex j-center">
				<div class="buzhouann inline-block br-20 ys-0 tit-14 pt-13 pb-13 pl-26 pr-26 cur_pointer"
					@click="dialog = false">
					Register Now</div>
			</span>
		</el-dialog>
		<!-- <div v-if="!userLanguage"> -->
		<el-dialog title="Select country and language" top="20vh" class="languages montserRegular"
			:visible.sync="initial">
			<el-tabs v-model="languageName">
				<el-tab-pane v-for="(l, i) in language" :label="l.continent" :name="i.toString()">
		
					<div class="neirong">
						
						<div class="guojia flex a-center cur_pointer" v-for="(ll,ii) in l.countries" @click="xuan(ll.country)">
							
							<el-image class="mr-7 guojia_tu " fit="contain" :src="'http://tupian.jsydl.com.cn'+ll.countryIcon" style="width: .4rem; height: .2rem"></el-image>
							{{ll.country}}
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>
			<el-dialog title="Select Language" top="20vh" class="languages montserRegular" :visible.sync="initial2" @close="onClose">
				<el-select :popper-append-to-body="false" class="w100" v-model="value" placeholder="Select Language" @change="onChange">
					<el-option v-for="(item,key) in options" :key="key" :label="`${item.name}（${item.code}）`" :value="key">
					</el-option>
				</el-select>
				<span slot="footer" class="flex j-center">
					<div class="buzhouann inline-block br-20 ys-0 tit-14 cur_pointer t-center" style="width: 1.4rem;" @click="onGo"> GO </div>
					<div class="buzhouann inline-block br-20 ys-0 tit-14 cur_pointer t-center ml-15" style="width: 1.4rem;background: #A3A3A3 !important;" @click="onGuanbi"> CANCEL </div>
				</span>
			</el-dialog>
			<div v-if="yy=='PK' && xianshig">
				<el-dialog title="Select country and language" top="20vh" class="languages montserRegular"
					:visible.sync="initial6">
					<el-tabs v-model="languageName">
						<el-tab-pane v-for="(l, i) in language" :label="l.continent" :name="i.toString()">
				
							<div class="neirong">
								
								<div class="guojia flex a-center cur_pointer" v-for="(ll,ii) in l.countries" @click="xuans(ll.country)">
									
									<el-image class="mr-7 guojia_tu" fit="contain" :src="ll.countryIcon" style="width: .4rem; height: .2rem"></el-image>
									{{ll.country}}
								</div>
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-dialog>
				<el-dialog title="Select Language" top="20vh" class="languages montserRegular" :visible.sync="initial7" @close="onClose">
					<el-select :popper-append-to-body="false" class="w100" v-model="value" placeholder="Select Language" @change="onChange">
						<el-option v-for="(item,key) in options" :key="key" :label="`${item.name}（${item.code}）`" :value="key">
						</el-option>
					</el-select>
					<span slot="footer" class="flex j-center">
						<div class="buzhouann inline-block br-20 ys-0 tit-14 cur_pointer t-center  " style="width: 1.4rem;" @click="onGo2"> GO </div>
						<div class="buzhouann inline-block br-20 ys-0 tit-14 cur_pointer t-center ml-15 " style="width: 1.4rem;background: #A3A3A3 !important;" @click="onGuanbi">
							<!-- CANCEL -->
							{{gudingziduan.Exam.Cancel}}
						</div>
					</span>
				</el-dialog>
			</div>
		<!-- </div> -->
		
	</div>

</template>

<script>
import { guanggao } from '@/api/banner.js';
import { language, continent } from '@/api/language.js';
import { confirmCountry,allUser,confirmCountrypk } from '@/api/user.js';
import {ExamQuestion} from '@/api/exam.js';
import { Playlistplues } from '@/api/resource.js';
import Tou from '../../../zuzuzu/touss.vue'
import Foot from '../../../zuzuzu/foot.vue'
import StayTact from '../../../components/StayTact.vue'
import {fenleilunbo} from '@/api/index.js';
import {myxiangqing} from '@/api/Personal.js';
			
export default {
	data() {
		return {
			mail: {},
			value: '',
			activeName: 'first',
			languageName: '0',
			xianshig:false,
			liuchenglie: [
				{ title: 'PREPARE', title2: 'Login with SEMS Account', anniu: 'Login now', text: "New to SEMS? Register now and join us!",text2:'*Use a SEMS Installer Organization representative account',url: 'login_in',url2:'https://www.semsportal.com/Home/InstallerOpenRegistration'},
				{ title: 'QUALIFY', title2: 'Pass the Exam to Unlock Membership ', anniu: 'Start Exam', text: "Learn First: Explore the GW Plus+ Exam Preparation Playlist", text2: "* Only SEMS Installers Are Eligible for This Program",url: 'exam',url2: 'video' }
			],
			lie: [
				{ title: 'QUALIFY', title2: 'Pass the certification exam', icon: "icon-zigerenzheng" },
				{ title: 'INSTALL', title2: 'Install GoodWe product', icon: "icon-anzhuangshigong" },
				{ title: 'EARN', title2: 'Earn points automatically for every installation', icon: "icon-zhuanjifen" },
				{ title: 'UPGRADE&REDEEM', title2: 'Upgrade your membership and unlock exclusive member benefits', icon: "icon-duihuan" },
			],
			lie2: [
				{ title: 'LOGIN LEARNING CENTER', text: 'Having a SEMS organization is a must for the login of Learning Center. ', url: "icon-denglu-mima" },
				{ title: 'COMPLETE THE TRAININGS', text: 'Select the two from six sessions that are most relevant for your business, and complete the trainings.', url: "icon-kejipeixun" },
				{ title: 'CONFIRM YOUR MEMBERSHIP', text: 'Pass the quizzes by the end of each session, an Email will be sent to you to confirm your membership. ', url: "icon-icon-ym-wf-receiptSign" },
				{ title: 'CONGRATS！', text: 'Congrats! Now you can log in your personal member page and start your GoodWe PLUS+ journey! ', url: "icon-icongongxiwancheng" },
			],
			// options: [{ value: 'en', label: 'English ‎(en)‎' }, { value: 'es_mx', label: 'Español' }],
			options: [],
			value: '',
			language: [],
			initial: false,
			initial2: false,
			initial6:false,
			initial7:false,
			dialog: false,
			dialog2: false,
			zongshu: 60,
			targetPage: '',
			userLanguage: '',
			sos: { jitiao: 6, ye: 1 },
			sow: { jitiao: 6, ye: 0,country:'',language:''},
			input: '',
			Playlistshu:[],
			userisPlus:null,
			activeNames: ['1'],
			datas: {},
			weidenglu:false,
			lunbolist:[],
			wentilie:[],
			gudingziduan:{},
			yonghus:{},
			yy:'',
			showPlus:'',
			yhgj:'',
			yhgjs:''
		}
	},
	components: { Tou, Foot, StayTact },
	mounted() {
		this.user()
		new this.$wow.WOW({
			live: false
		}).init()
		this.CSH()
		this.playlistlies()
		fenleilunbo({type:'PLUS'}).then(s=>{
			this.lunbolist=s.data
		})
		
		const sectionId = this.$route.query.section;
		if (sectionId) {
		  this.scrollToElement(sectionId);
		}
		// this.scrollToElement('section-id');
	},
	watch: {
	    '$store.state.cunyuanyan': {
	      handler(newValue, oldValue) {
	        // console.log('语言已更新:', newValue);
			this.yy=this.$store.state.yuyan
	        this.gudingziduan=this.$store.state.cunyuanyan
	      },
	      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
	    }
	},
	created: function () {
		this.user()
		guanggao().then(shu => {
			// console.log(shu)
		})
		this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		this.yy=this.$store.state.yuyan
		this.gudingziduan=this.$store.state.cunyuanyan
		// console.log(this.gudingziduan,'plus')
		ExamQuestion({"pageNum":this.sow.ye,"pageSize":this.sow.jitiao,country:this.sow.country,language:this.sow.language}).then(s=>{
			this.wentilie=s.data.content
		})
		this.$cun('Tindex', 2)
		
	},
	methods: {
		plus_xiangqing(id) {
			this.$router.push({
				name: "Playlists-details",
				params: { id: id }
			});
			// $dakai('Playlists-details?id='+l.id)
		},

		plusxq() {
			if(this.weidenglu){
				this.$alert('Please log in first', '', {
				  confirmButtonText: 'Log in',
				  confirmButtonClass:'Loginanniu',
				  distinguishCancelAndClose:true,
				  center:true,
				  roundButton:true,
				  callback: action => {
					  if(action=='confirm'){
							// this.$dakai('/login_in')
							this.$router.push({ name: 'login_in'})
					  }
				  }
				});
			}else{
				// console.log(this.userisPlus,'this.userisPlus')
				
				if(this.userisPlus) {
					if (this.userLanguage) {
						// this.$dakai('plus_details')
						this.$router.push({ name: 'plus_details'})
					} else{
						this.initial=true
					}
				}else {
					this.user()
					setTimeout(() => {
						if(this.userisPlus) {
							if (this.userLanguage) {
								// this.$dakai('plus_details')
								this.$router.push({ name: 'plus_details'})
							} else{
								this.initial=true
							}
						}else{
							this.$message({
							  showClose: true,
							  iconClass:'el-icon-warning',
							  customClass:'my-error-message',
							  message: this.gudingziduan.plus.JoinGOODWE+' Complete the certification exam to unlock your membership.',
							  type: 'error',
							  offset:'350',
							  duration:0
							});
						}
					}, 2000);
					
				}
				
			}
			
		},
		playlistlies(){
			Playlistplues().then(shu=>{
				this.Playlistshu=shu.data
			})
		},
		scrollToElement(elementId) {
		  const element = document.getElementById(elementId);
		  // console.log(element.offsetTop,'elementelementelement')
		  if (element) {
			setTimeout(()=>{
				window.scrollTo({
				  top: element.offsetTop - this.$refs.myElement.$el.offsetHeight, // 使用动态获取的导航栏高度
				  behavior: 'smooth' // 平滑滚动效果
				});
			},300)
		  }
		},
		onChange(e) {
			
			this.datas = {
				"country": this.options[e].country,
				"language": this.options[e].name
			}
			
		},
		onGo() {
			if(this.datas) {
				confirmCountry(this.datas).then(shu => {
					if(shu.code == '200') {
						this.initial = false
						this.initial2 = false
						this.CSH()
					}
				})
			}
		},
		onGo2(){
			var that=this
			if(that.datas) {
				confirmCountrypk(that.datas).then(shu => {
					if(shu.code ==200){
						that.initial6 = false
						that.initial7= false
						that.CSH()
						that.$dakai('/plus_details')
					}
				})
			}
		},
		onGuanbi() {
			this.initial2 = false
			this.datas = {}
		},
		CSH() {
			var that=this
			myxiangqing().then(res => {
				that.yhgj=res.data.plusRegion
				if(that.yhgj=='hk'){
					that.showPlus=1
				}else{
					that.showPlus=''
				}
				continent({showPlus:that.showPlus}).then(shu => {
					if(shu.code=='200') {
						that.language = shu.data
					}
					
				})
			})
		},
		user() {
			allUser().then(shu => {
				if(shu.code=='200') {
					this.userLanguage = shu.data.language
					this.userisPlus = shu.data.isPlus
					// if(!this.userLanguage)this.initial=true
					this.sow.country=shu.data.country
					this.sow.language=shu.data.language
					this.yonghus=shu.data
				}else{
					this.weidenglu=true
					this.userLanguage=''
					// this.$confirm(shu.message).then(_ => {this.$dakai('login_in') })
					if(this.$qu('kouling')!=[] && this.$qu('kouling')!=''){
						location.reload();
					}
					// this.$dakai('login_in')
					} 
			})
		},
		handleClick(tab, event) {
			// console.log(tab, event);
		},
		handleClick(tab, event) {
			// console.log(tab, event);
		},
		handleChange(val) {
			// console.log(val);
		},
		send() {
		},
		daikaiwaibu() {
			window.open('https://www.semsportal.com/Home/InstallerOpenRegistration', '_blank');
		},
		tiaodenglu(e){
			if(this.weidenglu){
				this.$dakai('/login_in')
			}else{
				this.$message({
				  showClose: true,
				  message:'logged in',
				  type: 'success',
				  offset:'350',
				  duration:0
				})
				
			}
			
		},
		daikaiUrl(i) {
			let url = ''
			if(i==0) {
				url = 'https://www.semsportal.com/Home/InstallerOpenRegistration'
			}else if(i==1) {
				url = 'exam'
			}else if(i==3) {
				url = 'video'
			}else if(i==4) {
				url = 'https://www.semsportal.com/home/login'
			}
			console.log(this.weidenglu)
			if(this.weidenglu && i!=0  && i!=4 && url!='video'){
				// this.$dakai('login_in')
				this.$alert('Please log in first', '', {
				  confirmButtonText: 'Log in',
				  confirmButtonClass:'Loginanniu',
				  distinguishCancelAndClose:true,
				  center:true,
				  roundButton:true,
				  callback: action => {
					  if(action=='confirm'){
							// this.$dakai('/login_in')
							this.$router.push({ name: 'login_in'})
					  }
				  }
				});
			}else{
				if(i==0 || i==4) {
					window.open(url);
				}else if(i==1) {
					if(this.yy=='PK'){
						if(this.yhgj=='hk'){
							this.xianshig=true
							this.initial6=true
						}else{
							this.$message({
							  showClose: true,
							  iconClass:'el-icon-warning',
							  customClass:'my-error-message',
							  message: "You don't have permission. Please select another language",
							  type: 'error',
							  offset:'350',
							  duration:0
							});
						}
						console.log(this.initial6,'this.initial6')
						console.log(this.xianshig,'this.xianshig')
					}else{
						if(this.userisPlus){
							this.$message({
							  showClose: true,
							  iconClass:'el-icon-warning',
							  customClass:'my-error-message',
							  message: 'You are already a GoodWe PLUS+ member. No need to retake the exam.',
							  type: 'error',
							  offset:'350',
							  duration:0
							});
						}else if(this.yonghus.organizationCode && this.yonghus.representative==1){
							this.$dakai(url)
						}else{
							this.$message({
							  showClose: true,
							  iconClass:'el-icon-warning',
							  customClass:'my-error-message',
							  message: 'Only SEMS Installers Are Eligible for This Program',
							  type: 'error',
							  offset:'350',
							  duration:0
							});
						}
					}
				}else if(i==3) {
					// window.open(url);
					this.$dakai(url)
				}
			}
		},
		xuan(id) {
			language({country:id}).then(shu => {
				this.options = shu.data
			})
			this.initial2 = true
			this.initial = false
		},
		xuans(id){
			var that=this
			myxiangqing().then(res => {
				that.yhgjs=res.data.plusRegion
				if(that.yhgjs=='hk'){
					that.showPlus=1
				}else{
					that.showPlus=''
				}
				// ,showPlus:that.showPlus
				language({country:id}).then(shu => {
					this.options = shu.data
					this.initial7 = true
					this.initial6 = false
					
				})
			})
		},
		onClose() {
			this.value = ''
			this.datas = {}
			this.initial2 = false
			this.initial = true
		},
		onClick(e) {
			if (e == 0) {
				this.dialog = true
			} else if (e == 3) {
				// this.$dakai('login_plus')
				this.$router.push({ name: 'login_plus'})
			}

		},
		goToPage() {
			const page = parseInt(this.targetPage);
			if (page && page > 0 && page <= Math.ceil(this.zongshu / 10)) { // 假设每页 10 项  
				this.sos.ye = page;
				this.targetPage = ''; // 清空输入框  
			} else {
				this.$message.error('Please enter a valid page number');
			}
		}
	}
}
</script>

<style lang="scss" scoped>
body {
	background-color: #F2F2F2 !important;
}

.fadeup {
	animation: fadeInUp 1s ease both;
	animation-delay: 0.4s;
}
::v-deep .el-select{
	padding: .1rem 0;
	border: 1px solid #c7c7c7;
	border-radius: 10px;
	.el-input .el-select__caret {
		line-height: 16px;
	}
	.el-input__inner {border: none;}
}
.plus {

	.moreLie {
		width: 22%;
		border-radius: .2rem;
		margin-right: 4%;
		.el-image {
			width: 100%;
		}

		.tit-20 {margin-top: .1rem;}
	}
	.moreLie:nth-of-type(4) {
	    margin-right: 0;
	}
	.el-tabs__nav-wrap::after {
		background-color: #E9E9E9;
	}

	// 语言
	
	::v-deep .el-popper {
		.el-select-dropdown__item.selected {color: #E60012 !important;}
	}
	::v-deep .languages {
		.el-dialog {
			width: 60%;
			padding: .22rem .17rem;
		}

		.el-dialog__title {
			font-size: var(--font22);
		}

		.el-dialog__body {
			padding: .1rem .2rem;
		}

		.is-active {
			font-family: "montserRegular";
			font-weight: 700;
			color: #E60012;
		}

		.el-tabs__item {
			font-family: "montserLight";
			font-size: .15rem;
		}

		.neirong {
			background: #f9f9f9;
			border-radius: 10px;
			padding: .1rem .27rem;
					
			.guojia {
				padding: .08rem 0;
				i {
					margin-right: .1rem;
				}
				
			}
		}

		.el-dialog__close {
			color: #2E2E2E;
			font-size: .2rem;
		}

		.el-tabs__active-bar {
			background-color: #E60012;
		}
		
		.el-tabs__item:hover {
			color: #E60012 !important;
		}
		
	}

	// 提示注册

	.buzhouann {
		border-radius: 100px;
		padding: .1rem .25rem;
		background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%);
	}


	::v-deep .juzhong {
		.el-dialog {
			width: 400px;
			max-width: 95%;
		}

		.el-dialog__header {
			padding: 0;
		}

		.el-dialog__body {
			padding: 0;
			padding-top: .5rem;
			padding-bottom: .2rem;
		}

		.el-dialog__footer {
			padding: 0;
			padding-bottom: .4rem;
			text-align: center;

			input {}
		}

		.el-dialog__headerbtn {
			top: .15rem;
			right: .2rem;
			font-size: var(--font16);
		}

	}

	::v-deep .dialogCode {
		.el-dialog {
			width: 35%;
		}

		.el-dialog__header {
			padding: 0;
		}

		.el-dialog__body {
			padding: 0;
			padding-top: .5rem;
			padding-bottom: .2rem;
		}

		.el-dialog__footer {
			padding: 0 .32rem;
			padding-bottom: .4rem;
			text-align: center;

			.el-input__inner::placeholder {
				font-size: var(--font14);
			}
		}

		.el-dialog__headerbtn {
			top: .15rem;
			right: .2rem;
			font-size: var(--font16);
		}
	}

	.head1 {
		.el-image {
			height: .26rem;
		}
	}
	.head2 {
		.banner {}
		.head2_zil {
			box-shadow: 0px 0px 36px 0px rgba(106,106,106,0.05); 
			border-radius: 31px;

			padding: .5rem .4rem .6rem .7rem;
		}
		.head2_tt {
			width: 1.08rem;
			height: 1.08rem;
			background: #ededed;
			border-radius: .2rem;
			.el-image {
				width: .57rem;
				height: .45rem;
			}
		}
		.buzhou {
			.bu1 {
				width: .74rem;
				height: .74rem;
				min-height: 40px;
				min-width: 40px;
				z-index: 1;
			}

			.bu2 {
				width: .42rem;
				height: .42rem;
				min-height: 30px;
				min-width: 30px;
				background: #f6f6f8;
				z-index: 1;
			}

			.bu3 {
				width: .32rem;
				height: .32rem;
				min-height: 15px;
				min-width: 15px;
				background: linear-gradient(-39deg, #e70a16 0%, #ff785c 100%);
				z-index: 1;
			}

		}

		.buzhou::after {
			content: '';
			position: absolute;
			width: 100%;
			height: 2px;
			background: #f9f9f9;
			z-index: 0;
		}

		.buzhounr {
			padding-bottom: 1rem;
		}
	}
	.buzhounr3 {
		.item {position: relative; padding-bottom: 2.2rem;}
		.tubb {
			width: .7rem;
			height: .7rem;
			border-radius: 50%;
			min-height: 50px;
			min-width: 50px;
			.tubbb {
				width: .6rem;
				height: .6rem;
				min-height: 40px;
				min-width: 40px;
				background: linear-gradient(0deg,#ff785c 0%, #e70a16 100%);
				border-radius: 50%;
			}
		}
		.title22 {min-height: .44rem;}
		
		.image11 {position: absolute; bottom: 0; width: 100%; left: 0;}
	}
	
	.banner2 {
		padding: 1.6rem 0;
		background: url('../../../assets/pc/resouce/bgs.png') no-repeat center;
		background-size: cover;

	}

	.banner3 {
		.tulie {

			::v-deep .el-image {
				overflow: hidden;
				border-radius: .2rem;

				img {
					transition: .5s;
					object-fit: cover;
				}

				&:hover img {
					transform: scale(1.05);
				}
			}

			.item {
				position: relative;

				span {
					position: absolute;
					width: 100%;
					left: 0;
					bottom: 0;
					padding: .3rem .4rem;
					padding-right: .1rem;
					font-size: var(--font24);
					color: #fff;
					text-align: left;
					line-height: 1.2;
				}

			}

			.item1 {
				width: 42%;
			}

			.item2 {
				width: 28%;
			}

			.item3 {
				// width: 50%;
			}


		}
	}

	.banner4 {
		box-shadow: 0px 0px 22.56px 0px rgba(0, 0, 0, 0.03);

		.bann_l {
			width: 50%;
		}

		.bann_ltu {
			width: .73rem;
			height: .73rem;
			background: linear-gradient(-58deg, #e70a16 0%, #ff785c 100%);

		}

		.bann_r {
			width: 45%;
		}
	}

	.banner5 {
		background: url('../../../assets/pc/plus/plus13.jpg') no-repeat 100%;
		background-size: cover;

		.bann5_l {
			width: 6.86rem;

			.image6 {
				width: 2.22rem;
				height: 2.06rem;
			}

		}

		.bann5_r {
			flex: 1;
		}
	}

	::v-deep .banner6 {
		.el-icon-arrow-right:before {
			content: "\e6d9";
			color: #929292;
			font-weight: bold;
			font-size: var(--font14);
		}

		.el-collapse-item__header {
			height: auto;
			font-size: var(--font24);
			background: transparent;
			padding: .25rem 0;
			line-height: initial;
			justify-content: space-between;
		}
		.el-collapse-item__wrap {background: transparent;}
		.el-collapse-item__header.is-active {
			color: #E81018;
			font-family: "montserRegular";
		}

		.el-collapse-item__arrow {
			background: #ffffff;
			width: .37rem;
			height: .37rem;
			border: 1px solid #d4d4d4;
			border-radius: 50%;
			margin-left: .3rem;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
		}

		.el-collapse-item__content div {}

		.el-collapse-item__arrow.is-active {
			background: #f5f5f5;
			border: .01rem solid #f5f5f5;
			width: .37rem;
			height: .37rem;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.el-collapse-item__arrow.is-active:before {
			content: "\e6db";
			color: #e81017;
			font-weight: bold;
			font-size: 0.14rem;
		}
	}

	::v-deep.el-dialog {
		border-radius: .1rem;
	}

	::v-deep.el-dialog__footer {
		// padding-bottom: .5rem;
		padding: .3rem .2rem;
	}


	// 新增页面修改
	.head2_zil .le {min-height: 2.6rem;}
	.plusThreList .abs {z-index: -1;top: 20px;left: 50%; transform: translateX(-50%); width: 100%;}

	.plusFour {
		.list {justify-content: space-between;}
		.item {margin-right: 0; width: 21.5%;}
		.item .imgBox {position: relative; overflow: hidden;}
		.item .imgBox ::v-deep img {transition: .5s;}
		.item .icBox {position: absolute; right: 0; top: 0;width: 1rem;height: 1rem;background: rgba(51, 51, 51,.5); display: flex; align-items: center; justify-content: flex-start; border-radius: 50%;    transform: translateX(50%) translateY(-50%);}
		.item .icBox span {font-size: var(--font20); color: #fff; margin-top: 40%; margin-left: 20%;}
		.item .tit-20 {text-align: center; justify-content: center;}
		.item:hover .imgBox ::v-deep img {transform: scale(1.05);}

	}
}



// ==========================================================================================================================================================================
// 响应式
@media screen and (max-width:1024px) {
	.plus .banner5 .bann5_l {
		width: 29%;
	}
}


@media screen and (max-width:767px) {

	.tit-42 {font-size: var(--font30);}

	.plus {
		::v-deep .languages {
			.el-dialog {
				width: 95%;
			}
		}

		::v-deep .dialogCode .el-dialog {
			width: 95%;
		}

		.head1 > div {width: 100%; margin: .1rem 0; padding-left: .5rem;}

		.head2 .tit-42 {
			padding-bottom: .2rem;
		}

		.buzhouNum {
			display: none;
		}

		.buzhounr {
			flex-wrap: wrap;
		}

		.buzhounr>div {
			width: 100%;
		}

		.banner3 .tulie {
			flex-wrap: wrap;
		}

		.banner3 .tulie .item1 {
			width: 48%;
		}

		.banner3 .tulie .item2 {
			width: 48%;
		}

		.banner3 .tulie .item3 {
			width: 100%;
			margin-top: .3rem;
			flex-direction: row;

			.item {
				width: 48%;
			}
		}

		.banner4 {
			flex-wrap: wrap;
		}

		.banner4 .bann_l {
			width: 100%;
		}

		.banner4 .bann_r {
			width: 100%;
		}


	}

	.plus .banner5 {
		padding-top: 0;
	}

	.plus .banner5>.w1500 {
		flex-wrap: wrap;
	}

	.plus .banner5 .bann5_l {
		width: 100%;
	}

	.plus .banner5 .bann5_r {
		width: 100%;
		flex: none;
		margin: 0;
		padding-top: .3rem;
	}

	.head2_zilBox {flex-wrap: wrap;}
	.head2_zilBox .head2_zil {padding: .4rem;width: 100%; margin-top: .3rem;}
	.plus .plusThreList .abs {display: none;}
	.plusThreList .buzhounr3 {flex-wrap: wrap; justify-content: space-between;}
	.plusThreList .buzhounr3 .item {width: 47%; margin-bottom: .3rem;}
	.plusFour .tit2 {width: 100%;}
	.plusFour .moreLie {margin-top: .2rem;}
	.plus .plusFour .item {width: 42.5%;}

}
</style>